const KEY = "tc-checkin-device";
let memory = null;

function randomSecret() {
  const bytes = new Uint8Array(24);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

/**
 * A random secret this browser keeps, so a check-in link only works in the browser that scanned the code. It lives in
 * localStorage (shared between tabs, so a magic link opened in a new tab still matches); if storage is blocked it
 * falls back to memory for the life of the page. It never leaves the browser except as a request body value.
 */
export function getDeviceSecret() {
  try {
    const existing = window.localStorage.getItem(KEY);
    if (existing && existing.length >= 16) return existing;
    const created = randomSecret();
    window.localStorage.setItem(KEY, created);
    return created;
  } catch {
    if (!memory) memory = randomSecret();
    return memory;
  }
}
